import 'lightgallery/dist/js/lightgallery.js'
import 'lg-video/dist/lg-video.js'

var $gallery = $('.lightgallery')
$gallery.lightGallery({
	selector: '.zoom',
	mode: 'lg-fade',
	// startClass: 'lg-start-m-fade',
	//height: '100%',
	enableDrag: false,
	zoom: false,
	hash: false,
	loop: false,
	counter: false,
	download: false,
	controls: true,
	thumbnail: false,
	hideBarsDelay: 1000000,
	// plugins: [lgVideo],
	youtubePlayerParams: {
		modestbranding: 0,
		showinfo: 0,
		rel: 0,
		controls: 0
  	},
	vimeoPlayerParams: {
		byline : 0,
		portrait : 0,
		color : 'FFFFFF'
  	}
})